export const logo = 'https://t4.ftcdn.net/jpg/05/80/27/13/360_F_580271394_Dm7IAVcu8YqSlafeEN1LlvyC3FcQg9TO.jpg'
export const icon = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRd0Nf0-_yYuOp4xUQehunvJBjRswm8vQQ0xA&s'
